import axios from './BaseService';
import { getDefaultFiat } from '../components/SelectFiat/SelectFiat';

const EXCHANGE_URL = `${process.env.REACT_APP_API_URL}/exchange/`;

export const STOP_TYPES = ["STOP", "STOP_MARKET", "TAKE_PROFIT_MARKET", "STOP_LOSS", "STOP_LOSS_LIMIT", "TAKE_PROFIT", "TAKE_PROFIT_LIMIT"];

export const LIMIT_TYPES = ["LIMIT", "STOP", "TAKE_PROFIT", "STOP_LOSS_LIMIT", "TAKE_PROFIT_LIMIT"];

export const MARKET_TYPES = ["MARKET", "STOP_MARKET", "TAKE_PROFIT_MARKET", "TRAILING_STOP_MARKET"];

export const FINISHED_STATUS = ["FILLED", "REJECTED", "CANCELED", "EXPIRED", "NEW_INSURANCE", "NEW_ADL"];

export async function getBalance(isFuture = false) {
    const query = isFuture ? "?isFuture=true" : "";
    const response = await axios.get(`${EXCHANGE_URL}balance/${getDefaultFiat()}${query}`);
    return response.data;
}

export async function getFullBalance(fiat, isFuture = false) {
    const query = isFuture ? "?isFuture=true" : "";
    const response = await axios.get(`${EXCHANGE_URL}balance/full/${fiat}${query}`);
    return response.data;
}

export async function getCoins() {
    const response = await axios.get(EXCHANGE_URL + 'coins');
    return response.data;
}

// Pass an optional TOTP code when 2FA is enabled. The backend returns
// 401 { twoFactorRequired: true } on the first (codeless) call; the caller
// prompts for a code and retries with `totp` set.
export async function doWithdraw(withdrawTemplateId, totp) {
    const body = totp ? { totp } : null;
    const response = await axios.post(`${EXCHANGE_URL}withdraw/${withdrawTemplateId}`, body);
    return response.data;
}

// KILL SWITCH — stop ALL of the caller's running bots across every engine
// (today / risk / futures). Returns a per-engine summary.
export async function stopAllBots() {
    const response = await axios.post(`${EXCHANGE_URL}stop-all`, null);
    return response.data;
}

export async function getOpenOrders() {
    const response = await axios.get(`${EXCHANGE_URL}orders/open`);
    return response.data;
}

// What the bots hold and the concrete price each will sell at for its profit target.
export async function getActiveTargets() {
    const response = await axios.get(`${EXCHANGE_URL}active-targets`);
    return response.data;
}

// Force a market-close of a bot position right now. The engine ('TODAY' | 'RISK')
// picks which sell endpoint to hit. Returns the updated session.
export async function sellNow(engine, sessionId) {
    const path = engine === 'TODAY'
        ? `${process.env.REACT_APP_API_URL}/today/sell-now/${sessionId}`
        : `${process.env.REACT_APP_API_URL}/risk/sell-now/${sessionId}`;
    const response = await axios.post(path, null);
    return response.data;
}

export async function cancelOrder(symbol, orderId) {
    const response = await axios.delete(`${EXCHANGE_URL}order/${symbol}/${orderId}`);
    return response.data;
}

export async function getFuturesPositions(symbol = '') {
    const response = await axios.get(`${EXCHANGE_URL}futures/${symbol}`);
    return response.data;
}

export async function closeFuturesPosition(symbol) {
    const response = await axios.delete(`${EXCHANGE_URL}futures/${symbol}`);
    return response.data;
}

export async function closeAllFuturesPositions() {
    const response = await axios.delete(`${EXCHANGE_URL}futures/all`);
    return response.data;
}

export async function updateFuturesPosition(symbol, params) {
    const response = await axios.patch(`${EXCHANGE_URL}futures/${symbol}`, params);
    return response.data;
}

// One-click: cancel resting orders on ASSET/USDC and market-sell the holding to USDC.
export async function convertToUsdc(asset) {
    const response = await axios.post(`${EXCHANGE_URL}convert`, { asset });
    return response.data;
}
